<script>

    //import data  from "../data/profesionales-asesores-cvs";
    import { onMount } from 'svelte'; 

    let data;

        onMount(async () => {

            const proxyurl = "";
            const url = 'https://plataforma.cvschile.cl/site/advisers';

            try {
                const response = await fetch(proxyurl + url);
                data = await response.json();
            } catch (error) {
                console.log(error);
            }

            var filterList = ['Apellido Paterno','Apellido Materno','Rut', 'N°'];
            var headerValues = Headers(data,filterList);
            var tableCols = headerValues[0];
            var originalColumns = headerValues[1];
            var dataSet = Body(data,originalColumns,filterList); 

            function Headers(list,filterList) {

                var columns = [];
                var originalColumns = [];
                var row = list[0]
                var inscriptionDate = null;
                var inscriptionNumber = null;

                for (var line in row) {
                    originalColumns.push(line);
                    if(window.$.inArray(line, filterList) == -1){
                        if(line == 'Nombre') line = 'Nombres y Apellidos';
                        if(line == 'Fecha Inscripción'){
                            inscriptionDate = {title: line};
                        }else if(line == 'N° Inscripción'){
                            inscriptionNumber = {title: line};
                        }else{
                            columns.push({title: line});
                        }
                    }
                }

                columns.push(inscriptionDate);
                columns.unshift(inscriptionNumber);

                return [columns,originalColumns];
            }

            function Body(list, originalColumns, filterList){

                var body = [];
                var bodyRow = [];
                var tempList = [];
                var lastNames = [];
                var fullName = '';

                for (let i = 0; i < list.length; i++) {

                    for (var colIndex = 0; colIndex < originalColumns.length; colIndex++){
                        if(originalColumns[colIndex] == 'Apellido Paterno' || originalColumns[colIndex] == 'Apellido Materno'){
                            lastNames.push(list[i][originalColumns[colIndex]]);
                        }
                        if(window.$.inArray(originalColumns[colIndex], filterList) == -1){

                            if(originalColumns[colIndex] == 'Fecha Inscripción'){
                                tempList.push(list[i][originalColumns[colIndex]]);
                            }else if(originalColumns[colIndex] == 'N° Inscripción'){
                                bodyRow.unshift(list[i][originalColumns[colIndex]]);
                            }else if(originalColumns[colIndex] == 'Nombre'){
                                fullName = list[i][originalColumns[colIndex]] + ' ' + lastNames[0] + ' ' + lastNames[1];
                                bodyRow.push(fullName);
                            }else{
                                bodyRow.push(list[i][originalColumns[colIndex]]);
                            }
                            
                        }
                    }

                    body.push(bodyRow.concat(tempList));

                    var bodyRow = [];
                    var tempList = [];
                    var lastNames = [];

                }

                return body;
            }

            var table = window.$('#dataTable').DataTable({
                responsive: true,
                data: dataSet,
                columns: tableCols,
                language: {
                    "sProcessing":     "Procesando...",
                    "sLengthMenu":     "Mostrar _MENU_ registros",
                    "sZeroRecords":    "No se encontraron resultados",
                    "sEmptyTable":     "Ningún dato disponible en esta tabla",
                    "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix":    "",
                    "sSearch":         "Buscar:",
                    "sUrl":            "",
                    "sInfoThousands":  ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst":    "Primero",
                        "sLast":     "Último",
                        "sNext":     "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    },
                    "buttons": {
                        "copy": "Copiar",
                        "colvis": "Visibilidad"
                    }
                }
            });

        });
    
</script>

<table id="dataTable" class="display nowrap" style="width:100%">

</table>
{#if !data}
<div class="d-flex justify-content-center">
    <div class="spinner-border" role="status" style="height: 100px;width: 100px;">
        <span class="sr-only">Loading...</span>
    </div>
</div>
{/if}
<style>

    #dataTable{
        font-size: 12pt !important;
        font-family: 'DINPro-Regular';
        color: #006937;
    }

    #dataTable{
        font-size: 12pt !important;
        font-family: 'DINPro-Regular';
        color: #006937;
    }

</style>
